import { VerticalSlicedMicroFrontendRoutes } from "@moodys/cre-cpm.constants.micro-frontends"

export const getBaseLocation = (
  baseRoute: VerticalSlicedMicroFrontendRoutes,
  location: string
): string => `${baseRoute}${location}`
